import { useEffect } from 'react';
import { useThree } from '@react-three/fiber';
import * as THREE from 'three';

function CameraController({ focusTarget }) {
  const { camera, scene } = useThree();

  useEffect(() => {
    if (!focusTarget) return;

    const object = scene.getObjectByName(focusTarget);
    if (!object) return;

    const box = new THREE.Box3().setFromObject(object);
    const center = new THREE.Vector3();
    box.getCenter(center);

    const size = new THREE.Vector3();
    box.getSize(size);
    const maxDim = Math.max(size.x, size.y, size.z);
    const newZ = center.z + maxDim * 2;
    const newPos = new THREE.Vector3(center.x, center.y, newZ);

    camera.position.lerp(newPos, 0.1);
    camera.lookAt(center);
    camera.updateProjectionMatrix();

    const distance = camera.position.distanceTo(center);
    const zoomFactor = 1.5;
    camera.zoom = Math.min(Math.max(1, (10 / distance) * zoomFactor), 10);
    camera.updateProjectionMatrix();
  }, [focusTarget, camera, scene]);

  return null;
}

export default CameraController;
